var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"210px","width":"445px"},attrs:{"id":"trend-chart"}})
}
var staticRenderFns = []

export { render, staticRenderFns }